@use "@fukuri-admins/ui/layout" as *;

.DashboardLayout {
  display: flex;
  background-color: $BackgroundGray;
  padding-left: $SideMenuWidth;
  min-height: 100vh;
  @media screen and (max-width: $TB) {
    flex-direction: column;
    padding-left: 0;
    background-color: background('Secondary');
  }
  &__SideMenuFooter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    text-align: center;
    color: $White;
    font-weight: 600;
    background-color: #21e4a3;
    font-size: 16px;
    @media screen and (max-width: $TB) {
      display: none;
    }
  }
}
